import { create } from 'zustand'
import type { ModuleType } from '@/types'

interface ActiveProject {
  id: string
  name: string
  moduleTypes: ModuleType[]
}

interface ProjectContextState {
  activeProject: ActiveProject | null
  setActiveProject: (project: ActiveProject | null) => void
  clearProject: () => void
}

export const useProjectContextStore = create<ProjectContextState>()((set) => ({
  activeProject: null,
  setActiveProject: (project) => set({ activeProject: project }),
  clearProject: () => set({ activeProject: null }),
}))
